import type { ButtonProps } from '@base-ui/react';

import type { MutuallyExclusive } from '~/types/utils';

import { clsx } from '~/styles/utils';

import type { IconName } from '../Icon/Icon';

import { buttonStyle, emphasisButtonStyles, iconOnlyButtonStyle, iconPlacementButtonStyles } from './Button.css';

export type ButtonEmphasis = 'primary' | 'secondary' | 'tertiary' | 'status';

type TextButtonProps = {
  'aria-label'?: string;
  children: NonNullable<ButtonProps['children']>;
  emphasis?: ButtonEmphasis;
  icon?: IconName;
  iconPlacement?: 'left' | 'right';
};

type IconButtonProps = {
  'aria-label': string;
  emphasis?: ButtonEmphasis;
  icon: IconName;
};

export type SharedButtonProps = MutuallyExclusive<TextButtonProps, IconButtonProps>;

export const defaultEmphasis = (props: Pick<SharedButtonProps, 'children'>): ButtonEmphasis => {
  const isIconOnly = !('children' in props) || props.children === undefined;

  return isIconOnly ? 'tertiary' : 'primary';
};

export const getSharedButtonClassNames = (props: Pick<SharedButtonProps, 'children' | 'emphasis' | 'icon' | 'iconPlacement'>) => {
  const isIconOnly = !('children' in props) || props.children === undefined;

  return clsx(
    buttonStyle,
    emphasisButtonStyles[props.emphasis ?? defaultEmphasis(props)],
    !!props.icon && !isIconOnly && iconPlacementButtonStyles[props.iconPlacement ?? 'left'],
    isIconOnly && iconOnlyButtonStyle,
  );
};
